import { render, staticRenderFns } from "./dataPresentation.vue?vue&type=template&id=35415764&scoped=true"
import script from "./dataPresentation.vue?vue&type=script&lang=js"
export * from "./dataPresentation.vue?vue&type=script&lang=js"
import style0 from "./dataPresentation.vue?vue&type=style&index=0&id=35415764&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35415764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35415764')) {
      api.createRecord('35415764', component.options)
    } else {
      api.reload('35415764', component.options)
    }
    module.hot.accept("./dataPresentation.vue?vue&type=template&id=35415764&scoped=true", function () {
      api.rerender('35415764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataMarket/components/dataPresentation.vue"
export default component.exports